import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'user-autherror',
    templateUrl: './user.autherror.component.html',
    styleUrls: ['./user.autherror.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class UserAuthErrorComponent implements OnInit {
    ngOnInit() {
        
    }
}